import type { AuthPermissionUser } from '../../services/authPermissions';

const SUPPLIER_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageSuppliers(user: AuthPermissionUser | null | undefined): boolean {
  return SUPPLIER_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteSupplier(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}
